// remember to update reports

const ClassificationType = {
  CUSTOM: 0,
  RECEIVING_MEANS: 1,
  ORIGIN: 2,
  REPORTING_AGENT: 3,
  LEVEL: 4,
  NATURE: 5,
  RESPONSIBLE_DEPARTMENT: 6,
  INVOLVED_DEPARTMENT: 7,
  BUSINESS_UNIT: 8,
  BUSINESS_GROUP: 9,
  COMPLAINT_CLOSURE: 10,
  DSAR_REQUIREMENT_TYPE: 11,
  DSAR_CLOSURE: 12,
  OMBUDSMAN_CLOSURE: 13,
  OMBUDSMAN_NATURE: 14,
  OMBUDSMAN_SERVICE: 15,
  OMBUDSMAN_SEGMENT: 16,
  RELATED_PROJECT: 17,
  CHANNEL_CONFIDENCE: 18,
};

export default ClassificationType;
export const ClassificationTypeMap = {
  [ClassificationType.CUSTOM]: "custom_{id}",
  [ClassificationType.RECEIVING_MEANS]: "receivingMeans",
  [ClassificationType.ORIGIN]: "origin",
  [ClassificationType.REPORTING_AGENT]: "reportingAgent",
  [ClassificationType.LEVEL]: "level",
  [ClassificationType.NATURE]: "nature",
  [ClassificationType.RESPONSIBLE_DEPARTMENT]: "responsibleDepartment",
  [ClassificationType.INVOLVED_DEPARTMENT]: "involvedDepartment",
  [ClassificationType.BUSINESS_UNIT]: "businessUnit",
  [ClassificationType.BUSINESS_GROUP]: "businessGroup",
  [ClassificationType.COMPLAINT_CLOSURE]: "complaintClosure",
  [ClassificationType.DSAR_REQUIREMENT_TYPE]: "dsarRequirementType",
  [ClassificationType.DSAR_CLOSURE]: "dsarClosure",
  [ClassificationType.OMBUDSMAN_CLOSURE]: "ombudsmanClosure",
  [ClassificationType.OMBUDSMAN_NATURE]: "ombudsmanNature",
  [ClassificationType.OMBUDSMAN_SERVICE]: "ombudsmanService",
  [ClassificationType.OMBUDSMAN_SEGMENT]: "ombudsmanSegment",
  [ClassificationType.RELATED_PROJECT]: "relatedProject",
  [ClassificationType.CHANNEL_CONFIDENCE]: "channelConfidence",
};

export const ClassificationName = {
  "custom_{id}": "Customizado",
  receivingMeans: "Meio de Recebimento",
  origin: "Origem da Comunicação",
  reportingAgent: "Agente Denunciante",
  level: "Classificação/Classe Interna",
  nature: "Natureza",
  responsibleDepartment: "Área responsável pelo tratamento",
  involvedDepartment: "Setor",
  businessUnit: "Unidade",
  businessGroup: "Empresa do Grupo",
  relatedProject: "Contrato/Projeto",
  ombudsmanNature: "Natureza da Comunicação",
  ombudsmanService: "Serviço Reclamado",
  ombudsmanSegment: "Segmento do Cliente",
  channelConfidence: "Confiança no Canal",
};

export const ClassificationTypeIdMap = Object.entries(
  ClassificationTypeMap
).reduce((target, entry) => {
  // @ts-ignore
  target[entry[1]] = parseInt(entry[0]);
  return target;
}, {});
